import React, {useState} from 'react';
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import {ProductsList} from "../ProductsList/ProductsList";

const AboutUs = () => {
    const [searchTerm, setSearchTerm] = useState("");
    return (
        <div className="bg-offWhite p-0">
            <NavBar products={ProductsList} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
            <div style={{ paddingTop: "12rem" }}>
                <div className="d-flex justify-content-center" style={{ backgroundColor: "#A6CE3A" }}>
                    <h2 className="text-white fw-bold pt-5 pb-4">ABOUT US</h2>
                </div>
                <h4 className="text-center fw-bold mt-5 text-black fs-15">What We Stand For</h4>
                <div className="mx-auto mt-4 text-center text-grey" style={{ maxWidth: '800px', padding: '0 1rem', lineHeight: '1.8' }}>
                    <p>
                        Welcome to SYED KABIR UD DIN SHAHDULHA INDUSTRY – A Legacy of Innovation and Excellence. SKS Fans is proud to be a leading name in the fan manufacturing industry.
                        Known for our commitment to quality, craftsmanship, and innovation, we deliver products that combine durability, high performance, and timeless elegance.
                        Since our establishment, we have consistently produced fans that exceed customer expectations. Each product is crafted with precision engineering, premium materials, and a deep passion for excellence.
                    </p>
                    <p>
                        Our designs ensure optimal airflow, energy efficiency, and long-lasting reliability for every space. Our mission is to blend comfort with style, continuously evolving with modern technologies and market trends.
                        Whether your preference is modern minimalism or classic charm, our fans are thoughtfully designed to complement any setting.
                        At the heart of our success is a commitment to customer satisfaction and sustainable innovation. Every product reflects our values of trust, integrity, and forward-thinking design.
                    </p>
                    <p>
                        We are proud to serve homes, offices, and industries across the nation with products that deliver more than just utility—they bring comfort, beauty, and peace of mind.
                        SKS Fans is more than a manufacturer—we are a symbol of reliability, sophistication, and technological excellence.
                    </p>
                </div>
                <Footer />
            </div>
        </div>
    );
}
export default AboutUs;
